module.exports = __webpack_public_path__ + "img/warrantyFail.2c076ab2.png";